import { createClient } from '@supabase/supabase-js'
import { createGuardedFetch } from './auth/offlineGate'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
// SPEC-FRONTEND-PUBLISHABLE-KEY-MIGRATION-V1 (D-503): env の値をそのまま使う。形式(sb_publishable_ / eyJ)で分岐しない。
//   撤回したもの: SPEC-HOTFIX-APIKEY-FALLBACK-01 の「env が JWT でなければハードコードした legacy anon JWT を使う」分岐。
//   撤回の理由: このフォールバックがある限り legacy anon キーを無効化できない(無効化した瞬間に全 REST が 401 になる)。
//     当時の hotfix は「pinned supabase-js が新形式キーを扱えず REST 全滅」への緊急避難だった。
//   撤回してよい根拠(2026-08-27 実測 / 実際に入っている supabase-js 2.100.1):
//     publishable キーと legacy JWT で REST select・権限拒否テーブル・RPC の応答が完全に一致した
//     (staff=OK / stores=42501 / rpc=42501 が両者同一)。当時の症状は現行版では再現しない。
//   切り戻しは env を legacy JWT に戻すだけでよい(コードは形式に依存しないため無変更で追従する)。
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    '環境変数が未設定です。.env.local に VITE_SUPABASE_URL と VITE_SUPABASE_ANON_KEY を設定してください。'
  )
}

// D-304 IMPL_2: 圏外継続中に anon REST/Storage/Functions を構造的に止める守衛を global.fetch に挿す。
//   auth/v1 は通す(セッション復帰)。supabaseUrl/supabaseAnonKey の参照は不変。
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: { fetch: createGuardedFetch((...a) => fetch(...a)) },
})
